import React, { FC } from 'react'
import { ClassNameValue } from 'tailwind-merge'
import { Folder, Verified } from '@mui/icons-material'
import cn from '../../lib/utils/cn'
import { getFileNameAndExt } from '../../lib/utils/formatDocument'
import getFileIcon from '../../lib/utils/fileIcons'
import { Tooltip } from '../ui'

interface FileFormatIconProps {
	fileName?: string
	extension?: string
	className?: ClassNameValue
	classNameSignedWrapper?: ClassNameValue
	size?: number
	isFolder?: boolean
	isSigned?: boolean
}

const FileFormatIcon: FC<FileFormatIconProps> = ({
	fileName,
	extension,
	className,
	classNameSignedWrapper,
	size,
	isFolder,
	isSigned,
}) => {
	const ext = extension ?? getFileNameAndExt(fileName)?.ext

	if (isFolder || extension?.toLocaleLowerCase() === 'folder') {
		return <Folder className={cn('fill-text-secondary w-7 h-7', className)} />
	}

	const Icon = getFileIcon(ext)
	const icon = (
		<Icon
			width={size ?? 28}
			height={size ?? 28}
			className={cn(!size && 'w-7 h-7 min-w-7 min-h-7', className)}
		/>
	)

	return isSigned ? (
		<div className={cn("relative", classNameSignedWrapper)}>
			<Tooltip label="Document Signed" className="w-fit justify-center">
				<span className='w-2.5 h-2.5 bg-white absolute -top-[2px] -right-[1px] ' />
				<Verified className="w-5 h-5 fill-positive z-10 absolute -right-1.5 -top-1.5" />
			</Tooltip>
			{icon}
		</div>
	) : (
		icon
	)
}

export default FileFormatIcon
